import { Text, type TextProps } from '@chakra-ui/react';

export const EarnPpText = (props: TextProps) => (
  <Text color="text.secondary" fontWeight="500" fontSize="xl" flex={1} {...props}>
    The better your onchain metrics, the more Plume Points you earn!
    <br />
    Bonus Points reward consistent activity.
  </Text>
);
